import { render, staticRenderFns } from "./AddStockTemplate.vue?vue&type=template&id=51aaacb9&"
import script from "./AddStockTemplate.vue?vue&type=script&lang=js&"
export * from "./AddStockTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports